import { BetBarType } from "slotworks/components/betbar/bet-bar-component";
import Components from "slotworks/components/components";
import Layers from "slotworks/graphics/layers/layers";
import BetMenuFreespinsMediator from "slotworks/mediators/bet-menu-freespins-mediator";
import BetModel from "slotworks/model/bets/bet-model";
import GameState from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import SmartButton from "slotworks/smart-button/smart-button";
import { SmartButtonFlag } from "slotworks/smart-button/smart-button";
import State from "slotworks/state-machine/states/state";

export default class RevolverJumpToFreespins extends State {

    public onEnter() {
        // Update dummy trigger record to include the fact it did in fact trigger freespins
        const dummyRecord = GameState.getCurrentGame().getFirstRecord() as FreespinRecord;
        dummyRecord.beenPaid = true;

        const gameplay = GameState.getCurrentGame();
        const record = gameplay.getCurrentRecord() as FreespinRecord;

        // Increase remaining free spins and take away any won on this spin to simulate what count would be on previous result (which we don't have)
        const actualFreespins = record.remainingFreespins;
        record.remainingFreespins++;
        record.remainingFreespins -= record.freespinsWon;

        // Update smart button count
        SmartButton.setFlag(SmartButtonFlag.FREE_SPINS, true);

        Components.betBar.setBetOptions(BetModel.generateBetOptions());
        Components.betBar.setType(BetBarType.FREESPINS);
        new BetMenuFreespinsMediator().start().execute();

        // Reset back to correct free spin count
        record.remainingFreespins = actualFreespins;

        Components.betBar.winnings.setWinnings(record.creditsWon, gameplay.getRunningFreespinsWinTotal() - gameplay.getCurrentRecord().creditsWon);
        Components.betBar.setEnabled(false);

        this.changeOtherLayers();

        this.complete();
    }

    private changeOtherLayers() {
        if (Layers.Background.hasScene("freespins")) {
            Layers.Background.jumpToScene("freespins");
        }
        if (Layers.Header.hasScene("freespins")) {
            Layers.Header.jumpToScene("freespins");
        }

        Components.banner.setMode("freespins");
    }
}



// WEBPACK FOOTER //
// ./~/slotworks/integration/revolver/states/revolver-jump-to-freespins.ts